import React from "react";
import Button, { buttonStyles } from "../button/button";
import { FaRegSave } from "react-icons/fa";

import "./SaveLayoutButton.scss";
import { BASIC } from "../../utils/stripeUtils";
import { showModal } from "../../actions/modalActions";
import { PREMIM_ONLY_SAVE } from "../modal/modalTypes";
import { useSaveWrapper } from "../../custom-hooks/useSaveWrapper";
import { withDefaults } from "../../utils/withDefaults";
import { useAppSelector, useAppDispatch } from "../../hooks";
import type { ButtonActivationEvent } from "../button/button";

export interface SaveLayoutButtonProps {
  shouldShowIcon?: boolean;
}

export default function SaveLayoutButton(incomingProps: SaveLayoutButtonProps) {
  const props = withDefaults(incomingProps, saveLayoutButtonDefaultProps);

  const { planType } = useAppSelector(state => state.userDetails);
  const { isExperimentalMode } = useAppSelector(state => state.global);
  const dispatch = useAppDispatch();

  const { onSaveClick } = useSaveWrapper();

  const saveLayout = (event: ButtonActivationEvent) => {
    event.preventDefault();
    if (planType === BASIC && isExperimentalMode) {
      dispatch(showModal(PREMIM_ONLY_SAVE));
    } else {
      onSaveClick();
    }
  };

  return (
    <Button
      onClick={saveLayout}
      buttonStyle={buttonStyles.OPAQUE_BUTTON}
      isInDarkBackground={true}
      className="save-button"
    >
      {props.shouldShowIcon ? (
        <FaRegSave className="icon-button" aria-label="Save Icon" />
      ) : (
        "Save Layout"
      )}
    </Button>
  );
}

const saveLayoutButtonDefaultProps = {
  shouldShowIcon: false
};
